const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/meals/new.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/meals/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { RECENT_LINE_INGREDIENTS_FETCH_LIMIT } from '@/features/saved-meals/lib/constants';
import { listRecentLineIngredientsQuery } from '@/features/saved-meals/lib/list-recent-line-ingredients.query';
export const Route = createFileRoute('/_authenticated/resources/meals/new')({
  loader: ({
    context
  }) => {
    // Warms the Search tab's Recent list; not awaited so it never blocks the page.
    void context.queryClient.prefetchQuery(listRecentLineIngredientsQuery({
      controllers: {
        savedMealController: context.deps.controllers.savedMealController
      }
    }, RECENT_LINE_INGREDIENTS_FETCH_LIMIT));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});